import { useQuery } from '@tanstack/react-query';
import axiosInstance, { getAPIURL } from '../axiosInstance';
import { GetMessages } from '../../types/Types';

interface UseGetMessagesProps {
  id: string;
  enabled?: boolean;
}

export function useGetMessages({ id, enabled = true }: UseGetMessagesProps) {
  return useQuery({
    enabled,
    queryKey: ['getMessages', id],
    queryFn: async () => {
      return axiosInstance<GetMessages[]>(getAPIURL(`/Message/userId/${id}/`)).then(
        (response) => response.data,
      );
    },
  });
}